import React, { Component } from 'react';
import creditCards from '../../../images/credit-cards.png';
import spinner from '../../../images/loading-spinner.gif';
import { ROOM_TYPE } from '../RoomsContainer.js';
import { USER_TYPE } from '../../../App';
import { translate } from 'react-i18next';

class Payment extends Component {
  render() {
    const isMember = this.props.user.member !== USER_TYPE.GUEST;
    const user = this.props.user;
    const room = this.props.room;
    const { t } = this.props;
    return(
      <div className="jumbotron panel-resvations">
        <h4 className="page-header text-primary">
          <strong>{t('dashboard.room_payment.heading_userinfo')}</strong>
        </h4>
        <form method="post" onSubmit={this.props.handlePaymentSubmit}>
          <fieldset>
            <div className="row">
              <div className="col-sm-12">
                <div className="form-group">
                  <input
                    className="form-control"
                    onChange={this.props.handleEmailChange}
                    placeholder={t('dashboard.room_payment.holder_email')}
                    readOnly={!user.no_account}
                    required={user.no_account}
                    type="email"
                    value={user.email || ""} />
                </div>
              </div>
              <div className="col-sm-6">
                <div className="form-group">
                  <input
                    className="form-control"
                    onChange={this.props.handleNameChange}
                    placeholder={t('dashboard.room_payment.holder_name')}
                    readOnly={!user.no_account}
                    required={user.no_account}
                    type="text"
                    value={user.name || ""} />
                </div>
              </div>
              <div className="col-sm-6">
                <div className="form-group">
                  <input
                    className="form-control"
                    onChange={this.props.handleLastnameChange}
                    placeholder={t('dashboard.room_payment.holder_lastname')}
                    readOnly={!user.no_account}
                    required={user.no_account}
                    type="text"
                    value={user.lastname || ""} />
                </div>
              </div>
              <div className="col-sm-6">
                <div className="form-group">
                  <input
                    className="form-control"
                    onChange={this.props.handlePhoneChange}
                    placeholder={t('dashboard.room_payment.holder_phone')}
                    required
                    type="tel"
                    value={user.phone || ""} />
                </div>
              </div>
              <div className={room.room_type === ROOM_TYPE.COWORK ? "hidden" : ""}>
                <div className="col-sm-6">
                  <div className="form-group">
                    <input
                      className="form-control"
                      max={room.capacity}
                      min="1"
                      onChange={this.props.handleReservationOccupancy}
                      placeholder={t('dashboard.room_payment.holder_occupancy')}
                      required={room.room_type === ROOM_TYPE.MEETING_ROOM}
                      type="number"
                      value={this.props.reservationOccupancy} />
                  </div>
                </div>
              </div>
              <div className={room.room_type === ROOM_TYPE.COWORK ? "hidden" : ""}>
                <div className="col-sm-12">
                  <div className="form-group">
                    <input
                      className="form-control"
                      onChange={this.props.handleReservationTitle}
                      placeholder={t('dashboard.room_payment.holder_restitle')}
                      required={room.room_type === ROOM_TYPE.MEETING_ROOM}
                      type="text"
                      value={this.props.reservationTitle} />
                  </div>
                </div>
              </div>
            </div>
            <div className={isMember ? "" : "hidden"}>
              <div className="form-group">
                <div className="checkbox">
                  <label>
                    <input
                      required={isMember}
                      type="checkbox"
                      value="" />
                    {t('dashboard.room_payment.terms')}
                  </label>
                </div>
              </div>
              <div className="form-group">
                <button
                  className="btn btn-primary btn-resvations"
                  disabled={this.props.isPaying}
                  type="submit">
                  {t('dashboard.room_payment.btn_credit')}
                </button>
                <img
                  className={this.props.isPaying ? "" : "hidden"}
                  width="45px"
                  height="45px"
                  alt={t('dashboard.room_payment.img_spinner')}
                  src={spinner} />
              </div>
            </div>
            <div className={isMember ? "hidden" : ""}>
              <h4 className="page-header text-primary">
                <strong>{t('dashboard.room_payment.heading_payment')}</strong>
              </h4>
              <div className="row">
                <div className="col-xs-12">
                  <div className="form-group">
                    <input
                      className="form-control"
                      onChange={this.props.handleCardName}
                      placeholder={t('dashboard.room_payment.holder_cname')}
                      required={!isMember}
                      type="text"
                      value={this.props.cardName ? this.props.cardName : "" } />
                  </div>
                </div>
                <div className="col-xs-12">
                  <div className="form-group">
                    <input
                      className="form-control"
                      maxLength="16"
                      onChange={this.props.handleCardNumber}
                      placeholder={t('dashboard.room_payment.holder_cnumber')}
                      required={!isMember}
                      type="text"
                      value={this.props.cnumber} />
                  </div>
                </div>
                <div className="col-xs-4">
                  <div className="form-group">
                    <input
                      className="form-control"
                      max="12"
                      min="1"
                      onChange={this.props.handleCardMonth}
                      placeholder={t('dashboard.room_payment.holder_cmonth')}
                      required={!isMember}
                      type="number"
                      value={this.props.cmonth} />
                  </div>
                </div>
                <div className="col-xs-4">
                  <div className="form-group">
                    <input
                      className="form-control"
                      max="99"
                      min="19"
                      onChange={this.props.handleCardYear}
                      placeholder={t('dashboard.room_payment.holder_cyear')}
                      required={!isMember}
                      type="number"
                      value={this.props.cyear} />
                  </div>
                </div>
                <div className="col-xs-4">
                  <div className="form-group">
                    <input
                      className="form-control"
                      maxLength="4"
                      onChange={this.props.handleCardCvc}
                      placeholder={t('dashboard.room_payment.holder_cvc')}
                      required={!isMember}
                      type="number"
                      value={this.props.cvc} />
                  </div>
                </div>
                <div className="col-xs-12">
                  <p>
                    <small className="text-muted">
                      {t('dashboard.room_payment.security')}
                    </small>
                  </p>
                </div>
                <div className="col-xs-12">
                  <div className="form-group">
                    <input
                      className="form-control"
                      onChange={this.props.handleStreetChange}
                      placeholder={t('dashboard.room_payment.holder_street')}
                      required={!isMember}
                      type="text"
                      value={this.props.street ? this.props.street : ""} />
                  </div>
                </div>
                <div className="col-xs-12 col-sm-8">
                  <div className="form-group">
                    <input
                      className="form-control"
                      onChange={this.props.handleNeighborhoodChange}
                      placeholder={t('dashboard.room_payment.holder_neighborhood')}
                      required={!isMember}
                      type="text"
                      value={this.props.neighborhood ? this.props.neighborhood : ""} />
                  </div>
                </div>
                <div className="col-xs-12 col-sm-4">
                  <div className="form-group">
                    <input
                      className="form-control"
                      onChange={this.props.handlePoChange}
                      placeholder={t('dashboard.room_payment.holder_po')}
                      required={!isMember}
                      type="number"
                      value={this.props.po ? this.props.po : ""} />
                  </div>
                </div>
                <div className="col-xs-12 col-sm-8">
                  <div className="form-group">
                    <input
                      className="form-control"
                      onChange={this.props.handleCityChange}
                      placeholder={t('dashboard.room_payment.holder_city')}
                      required={!isMember}
                      type="text"
                      value={this.props.city ? this.props.city :""} />
                  </div>
                </div>
                <div className="col-xs-12 col-sm-4">
                  <div className="form-group">
                    <input
                      className="form-control"
                      onChange={this.props.handleStateChange}
                      placeholder={t('dashboard.room_payment.holder_state')}
                      required={!isMember}
                      type="text"
                      value={this.props.state ? this.props.state : ""} />
                  </div>
                </div>
                <div className="col-xs-12 col-sm-4">
                  <div className="form-group">
                    <input
                      className="form-control"
                      onChange={this.props.handleCountryChange}
                      placeholder={t('dashboard.room_payment.holder_country')}
                      required={!isMember}
                      type="text"
                      value={this.props.country ? this.props.country : ""} />
                  </div>
                </div>
                <div className="col-xs-12">
                  <div className="form-group">
                    <div className="checkbox">
                      <label>
                        <input
                          required={!isMember}
                          type="checkbox"
                          value="" />
                        {t('dashboard.room_payment.terms')}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-xs-12">
                  <div className={this.props.error ? "" : "hidden"}>
                    <div className="alert alert-warning">
                      <i className="glyphicon glyphicon-remove pull-right" onClick={this.props.handleClearError} />
                      {this.props.error}
                    </div>
                  </div>
                </div>
                <div className="col-xs-6">
                  <div className="form-group">
                    <button
                      className="btn btn-primary btn-resvations"
                      disabled={this.props.isPaying}
                      type="submit">
                      {t('dashboard.room_payment.btn_pay')}
                    </button>
                    <img
                      className={this.props.isPaying ? "" : "hidden"}
                      width="45px"
                      height="45px"
                      alt={t('dashboard.room_payment.img_spinner')}
                      src={spinner} />
                  </div>
                </div>
                <div className="col-xs-6 text-right">
                  <img alt={t('dashboard.room_payment.img_credit')} width="150px" src={creditCards} />
                </div>
              </div>
            </div>
          </fieldset>
        </form>
      </div>
    );
  }
}

export default translate('common')(Payment);



// WEBPACK FOOTER //
// ./src/dashboard/reservations/payment/Payment.js